import { nanoid } from 'nanoid';

export function shortUid(): string {
  return nanoid(7);
}
